/* unplugin-vue-components disabled */import { render } from "./logic.vue?vue&type=template&id=4000660f&scoped=true"
import script from "./logic.vue?vue&type=script&lang=js"
export * from "./logic.vue?vue&type=script&lang=js"

import "./logic.vue?vue&type=style&index=0&id=4000660f&scoped=true&lang=css"

import exportComponent from "E:\\work\\weitu_land_page_h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4000660f"]])

export default __exports__